<template>
  <div class="form-success-result">
    <div class="form-success-result__content">
      <svg class="form-success-result__img" width="99" height="99" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="49.5" cy="49.5" r="49.5" fill="currentColor" />
        <path d="M26 50.7805L41.1488 66L73 34" stroke="white" stroke-width="5" stroke-linejoin="round" />
      </svg>

      <h3 class="form-success-result__title">{{ title }}</h3>
      <div class="form-success-result__text">{{ text }}</div>

      <div class="form-success-result__actions">
        <slot name="success-actions" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormSuccessResult',
  props: {
    title: {
      type: String,
      default: window.staticText.modal.successTitle,
    },
    text: {
      type: String,
      default: window.staticText.modal.successText2,
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.form-success-result
  margin-top: 48px
  min-width: 200px

  &__title
    margin-top: 32px
    line-height: 34px
    font-size: 28px

  &__text
    margin-top: 16px
    font-size: 19px
    line-height: 140%
    margin-bottom: 88px

  &__title, &__text
    color: #ffffff

  &__img
    color: #33BD82

  &__actions
    display: flex
    gap: 16px

    & > *
      color: var(--field-text-inverse-color)
      background-color: var(--form-action-bg-color)
      transition: color .2s, background-color .2s

      &:hover
        color: var(--form-action-text-hover-color)
        background-color: var(--form-action-bg-hover-color)
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/components/FormSuccessResult.vue